import { MAX_VALUE, MIN_VALUE } from "../types/card";

/** How many values a Match wraps round: 1 to 13. */
const SPAN = MAX_VALUE - MIN_VALUE + 1;

/**
 * How far apart two values are for a MATCH guess: the short way round a ring
 * where 13 sits next to 1. A 13 on a 1 is off by one, a 12 on a 1 off by two.
 *
 * Without the wrap a 1 or a 13 had one neighbour on each side cut off, so a
 * Match at the ends of the range was worse odds than in the middle for no
 * reason a player could see. Only Match wraps: Higher and Lower are about
 * ORDER, and a 1 is not higher than a 13.
 *
 * MIRRORED by MatchDistance in services/game-server/internal/engine/match.go.
 */
export function matchDistance(a: number, b: number): number {
  const d = Math.abs(a - b) % SPAN;
  return Math.min(d, SPAN - d);
}
